// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"0fcba4fb","239":"ea0c8587","453":"02a099c7","849":"723cb3c9"}[chunkId] + ".chunk.js";
};